/*
 * Validates a Gift Card Balance.
 */

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            wowGiftCardBalanceValidation: '@',
        },
        require: 'ngModel',
        link(scope, element, attrs, $ctrl) {
            $ctrl.$validators.giftCardBalanceEmpty = (modelValue) => {
                const balanceApiAvailable = scope.$eval(attrs.wowGiftCardBalanceValidation);

                if ($ctrl.$isEmpty(modelValue) && !balanceApiAvailable) {
                    return true;
                }

                // Must be greater than 0
                return modelValue > 0;
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/wallet/giftcard/gift-card-balance-validation.directive.js